class InputHandler {
    constructor() {
        document.getElementById('renderCanvas').addEventListener('pointerdown', () => this.startPointerDown());
        document.getElementById('renderCanvas').addEventListener('pointerup', () => this.startPointerUp());
    }
    startPointerDown() {
        this._isMouseDown = true;
        this._isClickValid = true;

        const _that = this;

        setTimeout( function() {
            _that._isClickValid = false;
        }, 250);

    }
    startPointerUp() {
        this._isMouseDown = false;
    }
}

export const inputHandler = new InputHandler();
export default inputHandler;
